export enum UserModelsRoutes {
  GetModel = 'get-model',
}
